export default __webpack_public_path__ + "static/media/municipalidad.6d22d7c1.png";